/**
 * Utility functions for generating job names
 */

/**
 * Generates a date-based job name in format MM-DD_XXXX
 * Example: "09-24_1234" for September 24th
 */
export const generateJobName = (): string => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(now.getDate()).padStart(2, '0');
  const randomId = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
  
  return `${month}-${day}_${randomId}`;
};

/**
 * Generates a date-based name for specific purposes (analysis, chat, etc.)
 * Example: "ANALYSIS-09-24_1234", "CHAT-09-24_1234"
 */
export const generatePrefixedJobName = (prefix: string): string => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const randomId = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
  
  return `${prefix.toUpperCase()}-${month}-${day}_${randomId}`;
};

/**
 * Legacy function for backward compatibility
 * @deprecated Use generateJobName() instead
 */
export const generateLegacyJobName = (): string => {
  return `Job-${Math.floor(Math.random() * 10000)}`;
};